import { render, staticRenderFns } from "./PitTable.vue?vue&type=template&id=accdd2da&"
import script from "./PitTable.vue?vue&type=script&lang=js&"
export * from "./PitTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports